import { render, staticRenderFns } from "./my-retrospective.page.vue?vue&type=template&id=1cb2170b&scoped=true&"
import script from "./my-retrospective.page.vue?vue&type=script&lang=js&"
export * from "./my-retrospective.page.vue?vue&type=script&lang=js&"
import style0 from "./my-retrospective.page.vue?vue&type=style&index=0&id=1cb2170b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb2170b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
